import request from '@/utils/request'
import qs from 'qs'
// 用户登录接口
export const reqLogin = (data) => request({
  method: 'post',
  url: '/users/admin/login/',
  data: qs.stringify(data),
  headers: {
    Accept: 'application/json'
  }
})

// 获取用户信息
export const GetUserInfo = () => request.get('/users/get_admin_info/')

// 获取手机验证码
export const GetPhoneCode = (data) => request.get('/sms_codes/', { params: data })

// 重置密码
export const PutPassword = (data) => request.post('/users/admin/forgot_password/', data)

// 修改用户的姓名和密码
export const PutUserInfo = (data) => request.put(`/users/admin/users/${data.id}/`, data)

